import { mapDataSource, RawDataSource } from '~/Api/DataSource';
import Price from '~/utils/Price';

import { CalculationPrice } from './CalculationPrice';

interface RawCalculationPriceProduct {
	id: string;
	dataSource: RawDataSource;
}

export interface RawCalculationPrice {
	currency: string;
	value: string;
	fromProducts: RawCalculationPriceProduct[];
}

export const mapCalculationPrice = (calculationPrice: RawCalculationPrice): CalculationPrice => ({
	price: new Price(calculationPrice.value, calculationPrice.currency),
	fromProducts: calculationPrice.fromProducts.map((product) => ({
		id: product.id,
		dataSource: mapDataSource(product.dataSource),
	})),
});
